import { Component, Watch } from 'vue-property-decorator';
import InsuranceService from '@/services/insurance.service';
import { InsuranceDTO } from '@/models/InsuranceDTO';
import { ThingDTO } from '@/models/ThingDTO';
import AutoComplete from '@/components/inputs/base/AutoComplete/AutoComplete';
import { WatchOptions } from 'vue';
import ApiError from '@/exceptions/api.error';

@Component
export default class InsuranceAutoComplete extends AutoComplete<InsuranceDTO> {
  public insurances: InsuranceDTO[] = [];
  public errorMessage: string = '';
  public error: boolean = false;

  public convertValue(): InsuranceDTO {
    return this.insurances.find((x) => x.insName === this.search.name) as InsuranceDTO;
  }

  public handleClickOutside(evt: any): void {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
      if (this.search && this.search.id === -99) {
        this.$emit('input', undefined);
        this.search.name = '';
      }
    }
  }

  protected onChange(value: string): void {
    super.onChange(value);
  }

  protected filterResults(): void {
    super.filterResults();
  }

  protected isSelected(i: number): boolean {
    return super.isSelected(i);
  }

  protected getId(index: number): string {
    return super.getId(index);
  }

  protected mounted() {
    this.loadInsurances();
    super.mounted();
  }

  protected loadInsurances(): void {
    InsuranceService.fetchInsurances()
      .then((res: InsuranceDTO[]) => {
        this.insurances = res.map((x) => x as InsuranceDTO);
        this.insurances.sort((a: InsuranceDTO, b: InsuranceDTO) => (a.insName > b.insName) ? 1 : -1);
        this.items = this.insurances.map((x: InsuranceDTO) => {
          return { name: x.insName, id: x.personId } as ThingDTO;
        });
      })
      .catch((error: ApiError) => {
        this.error = true;
        switch (error.status) {
          case (500):
            this.errorMessage = this.$i18n.t('errorMgs.serverError').toString();
            break;
          case (401):
            this.errorMessage = this.$i18n.t('errorMgs.sessionExpiration').toString();
            break;
          default:
            this.errorMessage = error.message;
        }
      });
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: InsuranceDTO, oldValue: InsuranceDTO) {
    if (oldValue !== value && value !== undefined && value !== null) {
      this.search = {
        id: value.personId,
        name: value.insName,
      } as ThingDTO;
    }

    if (value === null || value === undefined) {
      this.search = {} as ThingDTO;
    }
  }
}
